import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Tabs from './Tabs'
import Accordion from '../../ReportV2/components/Accordion'
import Select from '../../form/Select'
import Input from '../../form/Input'
import Spinner from '../../../UniformComponents/Spinner'

@observer
class MultiQuestionPicker extends PureComponent {
    integerNames = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'ninth', 'tenth', 'eleventh', 'twelth']

    constructor(props) {
        super(props)
        this.state = {
            error: {
                First: false,
                Second: false,
            },
        }
    }

    renderAccordion = (question, index) => {
        const { error } = this.state
        const { dashboardWizardStore } = this.props
        const {
            newWidget, getQuadrantQuestions,
        } = dashboardWizardStore

        const questions = getQuadrantQuestions(false, true)
        return (
            <div className="accordian" style={{ marginBottom: '15px' }}>
                <Accordion
                    cssClass="chartAccordian"
                    title={(
                        <div className="title">
                            {`${this.integerNames[index]} question`}
                            <i
                                className="fa-regular fa-circle-exclamation"
                                style={
                                    {
                                        color: 'red',
                                        background: 'none',
                                        marginLeft: '20px',
                                        display: R.pathOr(false, [this.integerNames[index]], error) ? 'block' : 'none',
                                    }
                                }
                            />
                        </div>
                    )}
                    openIcon="fa-regular fa-chevron-up"
                    closeIcon="fa-regular fa-chevron-down"
                >
                    <div className="questions" style={{ marginTop: '20px' }}>
                        <Select
                            label="Select Question"
                            onBlur={(value) => this.updateQuestions('question', value, index)}
                            options={questions}
                            defaultValue={R.pathOr(undefined, ['multiQuestion', index, 'value'], newWidget)}
                            isOptionSelected={(option, selectValue) => (
                                option.value === R.pathOr(undefined, [0, 'value'], selectValue)
                                && R.pathOr(undefined, [0, 'group'], selectValue) === option.group
                            )}
                            indentation
                            showSelected
                        />
                        <Input
                            style={{ marginTop: '20px' }}
                            id={this.integerNames[index]}
                            label="Name:"
                            onBlur={({ value }) => this.updateQuestions('name', value, index)}
                            defaultValue={R.pathOr(undefined, ['multiQuestion', index, 'name'], newWidget)}
                        />
                        {index > 1
                            ? (
                                <Button
                                    label="Remove Question"
                                    onClick={() => this.removeOption(index)}
                                    cssClass="secondary regular"
                                    style={{ width: '150px', margin: '20px auto' }}
                                />
                            )
                            : null}
                    </div>
                </Accordion>
            </div>
        )
    }

    renderAccordions = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget } = dashboardWizardStore
        const { multiQuestion } = newWidget
        return multiQuestion.map((q, i) => this.renderAccordion(q, i))
    }

    updateQuestions = (type, value, index) => {
        const { dashboardWizardStore } = this.props
        const { changeMultiQuestion, newWidget } = dashboardWizardStore
        const currentValue = newWidget.multiQuestion[index] || {}
        let newValue
        if (type === 'name') {
            newValue = { ...currentValue, name: value }
        } else {
            newValue = {
                name: currentValue.name,
                question: {
                    questionTypeCode: value.questionTypeCode,
                    id: value.id,
                    group: value.group,
                    label: value.label,
                    respondentType: value.respondentType,
                    parentId: value.parentId,
                    formId: value.formId,
                    isNps: R.pathOr(false, ['settings', 'frontend', 'renderNPS'], value)
                        || (R.pathOr(false, ['metadata', 'kpiType'], value) === 'NPS'),
                },
                value: value.value,
                respondentType: value.respondentType,
            }
        }
        changeMultiQuestion(newValue, index)
    }

    addOption = () => {
        const { dashboardWizardStore } = this.props
        const { addMultiQuestion, newWidget } = dashboardWizardStore
        addMultiQuestion()
        this.setState((prevState) => (
            { error: { ...prevState, [this.integerNames[newWidget.multiQuestion.length]]: false } }
        ))
    }

    removeOption = (index) => {
        const { dashboardWizardStore } = this.props
        const { removeMultiQuestion } = dashboardWizardStore
        removeMultiQuestion(index)
    }

    continue = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, nextStage } = dashboardWizardStore
        const { error } = this.state
        const errorClone = R.clone(error)
        let isValid = true
        newWidget.multiQuestion.forEach((q, i) => {
            errorClone[this.integerNames[i]] = !q.name || !q.question
            isValid = !!q.name && !!q.question
        })
        this.setState({ error: errorClone })
        if (!isValid) return
        nextStage()
    }

    render() {
        const { dashboardWizardStore } = this.props
        const { previousStage, loading, newWidget } = dashboardWizardStore
        const { multiQuestion } = newWidget
        if (loading) return <Spinner />
        return (
            <div className="multiQuestionPicker">
                <Tabs dashboardWizardStore={dashboardWizardStore} />
                <ModalHeader cssClass="header">
                    <div className="title">
                        Chart Options
                    </div>
                    <div className="subTitle">
                        Select your widget type
                    </div>
                </ModalHeader>
                <div className="body" style={{ padding: '0 100px' }}>
                    {this.renderAccordions()}
                    {multiQuestion.length >= 6
                        ? null
                        : (
                            <Button
                                cssClass="primary regular"
                                style={{ width: '100%' }}
                                onClick={this.addOption}
                            >
                                <i
                                    className="fa-light fa-plus"
                                    style={{
                                        marginRight: '10px',
                                        borderRadius: '50%',
                                        border: '1px solid white',
                                        width: '16px',
                                        height: '16px',
                                    }}
                                />
                                {' '}
                                Add another question
                            </Button>
                        )}
                </div>
                <ModalFooter>
                    <Button
                        label="Back"
                        cssClass="tertiary regular"
                        style={{ marginRight: '25px', width: '134px' }}
                        onClick={previousStage}
                    />
                    <Button
                        label="Continue"
                        cssClass="primary regular"
                        style={{ width: '134px' }}
                        onClick={this.continue}
                    />
                </ModalFooter>
            </div>
        )
    }
}

export default MultiQuestionPicker
